// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveLowerEnum } from '@/constants/case-insensitive-enum';
import { z } from 'zod';

export const assetTransitStatusSchema = caseInsensitiveLowerEnum([
  'in_transit',
  'not_in_transit',
  'in_transit_to_inventory',
  'in_transit_to_field',
]);

export type AssetTransitStatus = z.infer<typeof assetTransitStatusSchema>;
